import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={'100%'}
    height={undefined}
    viewBox="0 0 113 144"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M67.786 13.04 45.196 0 0 26.097l22.607 13.04L67.786 13.04ZM22.607 91.327l22.59-13.058 22.589-13.04-22.59-13.057-22.589 13.057L0 78.27l22.607 13.058ZM22.607 95.673 0 82.633v47.836l22.607 13.04V95.673ZM26.947 140.994l18.249-10.524 22.59-13.058h-.018l.035-.018V91.297l-22.59 13.04-18.266 10.541v26.116ZM112.982 39.141 90.41 26.101h-.017v26.08l22.589-13.04ZM45.214 30.438l22.572-13.04.017 43.514-22.59-13.04V30.438ZM113 43.5 90.393 56.522v73.952l22.589-13.058L113 43.5Z"
    />
  </svg>
)
export default SvgComponent
